import icon from 'vue-svgicon';

icon.register({
    'bold/analytics-bars-horizontal': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23 22H2.5a.5.5 0 0 1-.5-.5V1a1 1 0 0 0-2 0v21.522A1.48 1.48 0 0 0 1.479 24H23a1 1 0 0 0 0-2z"/><path pid="1" d="M5.5 20H21a1.443 1.443 0 0 0 1.5-1.375v-1.75A1.443 1.443 0 0 0 21 15.5H5.5A1.443 1.443 0 0 0 4 16.875v1.75A1.443 1.443 0 0 0 5.5 20zM4 11.625A1.443 1.443 0 0 0 5.5 13H15a1.443 1.443 0 0 0 1.5-1.375v-1.75A1.443 1.443 0 0 0 15 8.5H5.5A1.443 1.443 0 0 0 4 9.875zM5.5 6H10a1.443 1.443 0 0 0 1.5-1.375v-1.75A1.443 1.443 0 0 0 10 1.5H5.5A1.443 1.443 0 0 0 4 2.875v1.75A1.443 1.443 0 0 0 5.5 6z"/>`,
    },
});
